(function () {
    let languageSwitch = document.querySelectorAll('.diu-neos-structure-header__mobile .diu-neos-language-switch');
    if (languageSwitch.length > 0) {
        languageSwitch.forEach(function (langItem) {
            langItem.onclick = function () {
                if (this.classList.contains('js-active')) {
                    this.classList.remove('js-active');
                } else {
                    this.classList.add('js-active');
                }
            };
        });
    }
})();
